import * as React from 'react';

import Modal from '../_common/modal';
import DataFilterOptions from './data-filter-options';
import { ReactComponent as FilterIcon } from '../../assets/svg/icons/filter.svg';
import { getText } from '../../helpers';

const filter = getText('generic.filter');
export default function DataFilter(props: DataFiltersProps) {
    const [modalIsOpen, setModalOpen] = React.useState<boolean>(false);

    const { filterCount, filters } = props;

    return (filters && filters.length > 0) ? (

        <>
            <button
                className="button--select-control data-controls__button"
                type="button"
                onClick={() => setModalOpen(true)}
            >
                <FilterIcon />
                {filterCount > 0 ? `${filter} (${filterCount})` : filter}
            </button>
            <Modal
                open={modalIsOpen}
                onClose={() => setModalOpen(false)}
                isFullScreen={window.innerWidth < 1024}
            >
                <DataFilterOptions {...props} />
            </Modal>
        </>
    ) : <></>;
}
